/**
 * Kintsugi Design System — shadow effect primitives.
 *
 * Figma exposes named effect variables (not a full xs–2xl elevation scale).
 * Sourced from Kintsugi Design System — Tooltip node 260:4375 / Menu node 328:13683.
 *
 * `menu` — Figma variable **Menu Shadow**:
 * - DROP_SHADOW #1718181F, offset (0, 8), radius 20, spread -4
 * - DROP_SHADOW #17181814, offset (0, 3), radius 6, spread -3
 *
 * `popup` — Figma variable **Popup Shadow** (in-app review floating card, Dashboard 11599:40792):
 * - DROP_SHADOW #1718181F, offset (0, 8), radius 32, spread -4
 * - DROP_SHADOW #17181814, offset (0, -2), radius 26, spread -3
 */
export const shadowEffects = {
  menu: '0 8px 20px -4px #1718181F, 0 3px 6px -3px #17181814',
  popup: '0 8px 32px -4px #1718181F, 0 -2px 26px -3px #17181814',
} as const;

export type ShadowEffect = keyof typeof shadowEffects;
